<template>
    <div class="col-span-full bg-white border border-gray-200 rounded-2xl">
        <header class="p-4 flex space-x-4" v-if="title">
            <h2 class="font-semibold text-gray-900 flex-1" v-text="title"></h2>
            <slot name="actions" v-bind="scope"></slot>
        </header>
        <slot v-bind="scope"></slot>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        fetch: Function,
        filters: Object,
    },
    data () {
        return {
            report: {},
            loading: false,
        }
    },
    computed: {
        scope () {
            return {
                report: this.report,
                loading: this.loading,
                filters: this.filters,
                refresh: this.fetchReport,
            }
        },
    },
    methods: {
        async fetchReport () {
            this.loading = true
            try {
                this.report = await this.fetch(this.filters)
            } finally {
                this.loading = false
            }
        },
    },
    mounted () {
        this.fetchReport()
    },
    watch: {
        filters: {
            deep: true,
            handler () {
                this.$emit('filtersChanged', this.scope)
            },
        },
    },
}
</script>
